import React from 'react';
import { useSelector } from 'react-redux';
import { PageTitle, PageBreadcrumbs, Container, NotFound, SEOBlock } from 'common/components';

import { ConfiguratorsListingSection, pageTitleStyles } from './styled';
import { AdditionalText, Benefits, ConfiguratorsList } from './components';
import { selectConfigurators } from './selectors';

export const ConfiguratorsListing = () => {
	const configurators = useSelector(selectConfigurators);

	return (
		<ConfiguratorsListingSection id="categories-listing">
			<Container>
				<PageBreadcrumbs />
				<PageTitle className={pageTitleStyles} />
				{configurators.length ? (
					<>
						<Benefits />
						<ConfiguratorsList />
					</>
				) : (
					<NotFound
						description={
							'На\u00A0данный момент нет доступных услуг в\u00A0вашем городе'
						}
					/>
				)}
			</Container>
			<AdditionalText />
			<SEOBlock />
		</ConfiguratorsListingSection>
	);
};
